import {
  Sofa,
  Wifi,
  ChefHat,
  Car,
  ShieldCheck,
  Sparkles,
  Shirt,
  CarTaxiFront,
  Stethoscope,
  UtensilsCrossed,
} from "lucide-react";
import { FACILITIES } from "@/mock";

const ICON_MAP = {
  Sofa,
  Wifi,
  ChefHat,
  Car,
  ShieldCheck,
  Sparkles,
  Shirt,
  CarTaxiFront,
  Stethoscope,
  UtensilsCrossed,
};

const Facilities = () => {
  return (
    <section
      id="facilities"
      className="py-20 md:py-28 px-5 md:px-10 bg-white"
      data-testid="facilities-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-3">
            <span className="h-[1px] w-6 bg-[#C8A97E]" />
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#C8A97E] font-semibold">
              Why Choose Us
            </span>
            <span className="h-[1px] w-6 bg-[#C8A97E]" />
          </div>
          <h2 className="font-serif text-[40px] sm:text-[46px] font-semibold text-[#1A1A1A] leading-[1.1] mb-3">
            Every <em className="text-[#C8A97E] font-normal">Comfort</em> Included
          </h2>
          <p className="text-[15px] text-[#666] max-w-xl mx-auto leading-relaxed">
            10+ thoughtful facilities designed for seamless, luxurious living.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {FACILITIES.map((f, i) => {
            const Icon = ICON_MAP[f.icon] || Sparkles;
            return (
              <div
                key={f.name}
                className="group bg-[#F9F7F3] border border-[#E5E0D8] rounded-[16px] p-6 text-center hover:bg-white hover:border-[#C8A97E]/40 hover:-translate-y-1 hover:shadow-[0_10px_28px_rgba(0,0,0,0.06)] transition-all"
                data-testid={`facility-${f.name.toLowerCase().replace(/[\s&]+/g, "-")}`}
              >
                <div className="w-14 h-14 mx-auto rounded-[14px] bg-[#1A1A1A] group-hover:bg-gradient-to-br group-hover:from-[#C8A97E] group-hover:to-[#B0946B] flex items-center justify-center transition-all mb-4 shadow-[0_4px_14px_rgba(26,26,26,0.12)]">
                  <Icon className="w-6 h-6 text-[#C8A97E] group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <div className="font-sans text-[13px] font-semibold text-[#1A1A1A] mb-1.5">
                  {f.name}
                </div>
                <div className="text-[11px] text-[#9A9A9A] leading-relaxed">{f.desc}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
